import categoryDispatcher from '../action/category';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const categoryReducer = categoryDispatcher(initialState, {
  [categoryDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [categoryDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  })
});

export default categoryReducer;
